import classNames from 'classnames';
import { PersonLabelType } from 'components/Persons/types/personTypes';
import {
  getPersonLabelSourceTranslation,
  getPersonLabelSubValueTranslation,
  getPersonLabelValueTranslation,
} from 'components/Persons/utils/personUtils';
import styles from './PersonLabel.module.scss';

type PersonLabelProps = PersonLabelType & {
  onClick: () => void;
};

export const PersonLabel = ({ source, value, subValue, tooltip, disabled, onClick }: PersonLabelProps) => {
  const sourceTranslation = getPersonLabelSourceTranslation(source);
  const valueTranslation = getPersonLabelValueTranslation(source, value);
  const subValueTranslation = subValue ? getPersonLabelSubValueTranslation(source, subValue) : null;
  const classes = classNames(styles['person-label'], styles[source.toLowerCase()], { [styles.disabled]: disabled });

  return (
    <div
      className={classes}
      title={tooltip ? `${sourceTranslation} (${tooltip})` : sourceTranslation}
      onClick={() => onClick()}
    >
      <div className={styles.value}>{valueTranslation}</div>
      {subValue && <div className={styles.subvalue}>{subValueTranslation}</div>}
    </div>
  );
};
